package pwgs.ui.scenes.playererrorsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.div
import visage.dom.tag
import visage.ds.colorpalette.Skin
import visage.ds.components.*
import visage.ds.utils.EFontWeight
import kotlin.js.Date

class MPlayerErrorsScene(props: PlayerErrorsSceneProps) : AScene<PlayerErrorsSceneProps, PlayerErrorsSceneModel, PlayerErrorsSceneState, PlayerErrorsControllerFe>(props) {

    override fun createController() : PlayerErrorsControllerFe {
        return PlayerErrorsControllerFe(props, this)
    }

    override fun initState() : PlayerErrorsSceneState {
        return PlayerErrorsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MPlayerErrorsScene.model
        Card {
            isLoading = model.isLoading
            header("Issues")
            body {
                if (model.isLoading) {
                    return@body
                }
                ExpandableTable {
                    columns {
                        column("Message")
                        column("Date")
                    }
                    body {
                        model.issues.forEach {
                            row {
                                cell() {
                                    Text(it.message, TextStyle(16, EFontWeight.Medium, Skin.palette.errorColor, false), true)
                                }
                                cell(Date(it.createdAt).toLocaleString())
                                expandableContent {
                                    div {
                                        style.apply {
                                            width = "100%"
                                            padding = "16px"
                                        }

                                        Text("Player ID: ${it.userId}")
                                        Text("Player Name: ${it.userName}")
                                        Text("Device: ${it.device}")
                                        Text("Version: ${it.version}")

                                        div { style.height = "8px" }

                                        Text("Stack trace:", ETextStyles.Strong)
                                        tag("div") {
                                            style.apply {
                                                whiteSpace = "pre"
                                                width = "100%"
                                                maxWidth = "100%"
                                                color = Skin.palette.normalTextColor
                                                overflowX = "hidden"
                                            }
                                            +it.stackTrace
                                        }

                                        div { style.height = "16px" }

                                        Text("Bread crumbs:", ETextStyles.Strong)
                                        HistoryList {
                                            it.breadCrumbs.reversed().forEach { bc ->
                                                var t = ""
                                                var tm = bc.tMinus;
                                                if (tm < 1000) {
                                                    t = "-${tm} ms"
                                                } else {
                                                    t = "-${tm / 1000L} sec"
                                                }

                                                if (bc.type == "Info") {
                                                    itemWithIcon("info", bc.type, t, bc.message, Skin.palette.infoColor)
                                                } else if (bc.type == "Warning") {
                                                    itemWithIcon("warning", bc.type, t, bc.message, Skin.palette.warningColor)
                                                } else if (bc.type == "Error") {
                                                    itemWithIcon("error", bc.type, t, bc.message, Skin.palette.dangerColor)
                                                } else if (bc.type == "Exception") {
                                                    itemWithIcon("bug_report", bc.type, t, bc.message, Skin.palette.dangerColor)
                                                } else if (bc.type == "Scene loaded") {
                                                    itemWithIcon("input", bc.type, t, bc.message, Skin.palette.successColor)
                                                } else if (bc.type == "Scene unloaded") {
                                                    itemWithIcon("output", bc.type, t, bc.message, Skin.palette.infoColor)
                                                }
                                                else {
                                                    itemWithIcon("short_text", bc.type, t, bc.message, Skin.palette.normalTextColor)
                                                }

                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class PlayerErrorsSceneState {

}

fun Components.PlayerErrorsScene(props: PlayerErrorsSceneProps) = this.registerComponent(MPlayerErrorsScene(props), {})
